export default "__VITE_PUBLIC_ASSET__720eef18__"